import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertMinutesToHour',
  standalone: true
})
export class ConvertMinutesToHourPipe implements PipeTransform {
  public transform(minutes: number): string {
    let _minutes = Math.abs(minutes);
    let result = '';
    const hourInMinutes = 60;
    const minus = minutes < 0;

    if (_minutes === 0) {
      return '0м.';
    }

    if (minus) {
      result = result.concat('-');
    }

    const hours = Math.floor(_minutes / hourInMinutes);
    _minutes %= hourInMinutes;

    if (hours) {
      result = result.concat(`${hours}ч.`);
    }
    if (_minutes) {
      result = result.concat(` ${_minutes.toFixed(0)}м.`);
    }
    return result;
  }
}
